.wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    width: 100%;
    font-family: var(--tempest-font-sans);
}

.label {
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-semibold);
    color: var(--tempest-text);
    line-height: var(--tempest-leading-snug);
}

.dropzone {
    border: 2px dashed var(--tempest-border-strong);
    border-radius: var(--tempest-radius-lg);
    background-color: var(--tempest-surface);
    padding: var(--tempest-space-6) var(--tempest-space-5);
    text-align: center;
    cursor: pointer;
    transition: var(--tempest-transition-color);
}

@media (hover: hover) and (pointer: fine) {
    .dropzone:hover {
        border-color: var(--tempest-primary);
    }
}

.dropzone.active {
    border-color: var(--tempest-primary-on-soft);
    background-color: var(--tempest-primary-soft);
}

.dropzone.disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.icon {
    color: var(--tempest-text-muted);
    margin-bottom: var(--tempest-space-2);
}

.title {
    font-weight: var(--tempest-weight-semibold);
    color: var(--tempest-text);
    font-size: var(--tempest-text-base);
    margin: 0;
    line-height: var(--tempest-leading-snug);
}

.subtitle {
    color: var(--tempest-text-muted);
    font-size: var(--tempest-text-xs);
    margin: var(--tempest-space-1) 0 0;
    line-height: var(--tempest-leading-snug);
}

/* Mobile — replace dashed drop hint with simpler tap-to-upload text. */
@media (max-width: 767.98px) {
    .dropzone {
        padding: var(--tempest-space-5) var(--tempest-space-4);
    }
    .icon {
        margin-bottom: var(--tempest-space-1);
    }
}

.files {
    margin-top: var(--tempest-space-3);
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-2);
}

.file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--tempest-space-3);
    padding: var(--tempest-space-2) var(--tempest-space-3);
    background-color: var(--tempest-bg);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-md);
    font-size: var(--tempest-text-sm);
    box-shadow: var(--tempest-shadow-xs);
}

.fileMeta {
    color: var(--tempest-text-muted);
    font-size: var(--tempest-text-2xs);
}

.remove {
    background: none;
    border: none;
    color: var(--tempest-text-muted);
    cursor: pointer;
    padding: 4px;
    border-radius: var(--tempest-radius-sm);
    transition: var(--tempest-transition-color);
}

@media (hover: hover) and (pointer: fine) {
    .remove:hover {
        background-color: var(--tempest-surface);
        color: var(--tempest-danger);
    }
}

.hidden {
    display: none;
}
